import { DefaultRolePermissions, FeatureDefaults } from "../../../defaults/defaults";
import { HoldingUserPermissions } from "../types";
import { AppPermissionsTemplate } from "./templates";

export type ScoutPermissionsTemplate = AppPermissionsTemplate<HoldingUserPermissions["scout"]>

export const scoutPermissionsTemplate: ScoutPermissionsTemplate = {

    name: "Scout app",

    permissions: {

        app: {
            name: "App access",
            selector: a => a.app,
            isAvailable: (_, defaults) => checkDefaultPermissions(defaults, s => s.scoutAppAccess),
            type: "access"
        },

        fields: {
            name: "Fields",
            selector: a => a.fields,
            isAvailable: (_, defaults) => checkDefaultPermissions(defaults, s => s.fields),
            type: "readWrite"
        },

        records: {
            name: "Records",
            selector: a => a.records,
            isAvailable: (_, defaults) => checkDefaultPermissions(defaults, s => s.records),
            type: "readWrite"
        },

        tasks: {
            name: "Tasks",
            selector: a => a.tasks,
            isAvailable: (_, defaults) => checkDefaultPermissions(defaults, s => s.tasks),
            type: "readWrite"
        },

        stocks: {
            name: "Stocks",
            selector: a => a.stocks,
            isAvailable: (_, defaults) => checkDefaultPermissions(defaults, s => s.stocks),
            type: "readWrite"
        },

    }

} as const

function checkDefaultPermissions(defaultPermissions: DefaultRolePermissions, selector: (defaults: DefaultRolePermissions["scout"]) => FeatureDefaults): boolean {

    const scout = defaultPermissions?.scout

    if (!scout) {
        return true
    }

    const def = selector(scout)?.permissions

    if (!def) {
        return false
    }

    return def.admin || def.owner

}
